import { Bitmap, ingenuity } from "@quest/base-core";
import { BlurBackgroundController } from "@quest/murka-games-behavior-panther/dist";
import { gameConstants } from "../Constants/gameConstants";
import { IEvent } from "@quest/adapter-interface";

export class BlurBackgroundControllerGame extends BlurBackgroundController {
  protected collectionBlurBg: Bitmap;

  protected initializeElements(): void {
    super.initializeElements();
    this.collectionBlurBg = this.view.getImageById("CollectionScreenBlurBg");
    const blur1: any = (ingenuity.currentGame as any).add.filter("Blur");
    blur1.blurY = 10;
    this.view.getImageById("gameIntroBlurBg").filters = [blur1];
  }
  /**
   * overrided to hide game specific Backgrounds
   */
  protected hideAllBg(): void {
    super.hideAllBg();
    this.view.getImageById("reSpinIntroBlurImage") && (this.view.getImageById("reSpinIntroBlurImage").visible = false);
    this.view.getImageById("reSpinOutroBlurImage") && (this.view.getImageById("reSpinOutroBlurImage").visible = false);
    this.view.getImageById("JackpotBlurImage") && (this.view.getImageById("JackpotBlurImage").visible = false);
    this.collectionBlurBg.visible = false;
  }
  /**
   * overrided to handle game specific backgrounds
   */
  protected changeBackground(evt: IEvent): void {
    this.hideAllBg();
    switch (evt.data) {
      case gameConstants.FISH_TIME_INTRO_BLURBG_SHOW:
        this.showFishTimeIntroBlurBg();
        break;
      case gameConstants.FISH_TIME_OUTRO_BLURBG_SHOW:
        this.showFishTimeOutroBlurBg();
        break;
      case gameConstants.COLLECTION_BG:
        this.showCollectionBlurBg();
        break;
      case gameConstants.JACKPOT_BLUR_BG:
        this.showJPBlurBg();
        break;
      default:
        super.changeBackground(evt);
    }
  }

  /**
   * Displays the blur background image for the Fish Time intro screen,
   * if the "reSpinIntroBlurImage" is found in the view.
   */
  private showFishTimeIntroBlurBg(): void {
    this.view.getImageById("reSpinIntroBlurImage") && (this.view.getImageById("reSpinIntroBlurImage").visible = true);
  }

  /**
   * Displays the blur background image for the Jackpot screen,
   * if the "JackpotBlurImage" is found in the view.
   */
  private showJPBlurBg(): void {
    this.view.getImageById("JackpotBlurImage") && (this.view.getImageById("JackpotBlurImage").visible = true);
  }

  /**
   * Displays the blur background image for the Fish Time outro screen,
   * if the "reSpinOutroBlurImage" is found in the view.
   */
  private showFishTimeOutroBlurBg(): void {
    this.view.getImageById("reSpinOutroBlurImage") && (this.view.getImageById("reSpinOutroBlurImage").visible = true);
  }

  /**
   * Displays the blur background for the collection UI element.
   */
  private showCollectionBlurBg(): void {
    this.collectionBlurBg.visible = true;
  }
}

